/**
 * @fileoverview POST handler for the "/ai_agent/gemini_interactions/:app_group_id" endpoint
 */
import { fetchWithRetry } from "@lib/fetch";

import { serializeAttachedFiles } from "../aiAgentShared";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { aiAgentGeminiInteractionsAppGroupIdCacheKeys } from "./constants";
import type {
  AiAgentGeminiInteractionsAppGroupIdResult,
  PostAiAgentGeminiInteractionsAppGroupIdProps,
} from "./types";

export const postAiAgentGeminiInteractionsAppGroupId = reactQueryMutationAdapter(
  aiAgentGeminiInteractionsAppGroupIdCacheKeys,
  ({
    appGroupId,
    requestId,
    userMessageId,
    sessionId,
    model,
    input,
    mode,
    previousInteractionId,
    frontendTools,
    locale,
    browserLocale,
    transport,
    promptSource,
    mockResponseLength,
    dustSessionId,
    attachedFiles,
  }: PostAiAgentGeminiInteractionsAppGroupIdProps): Promise<AiAgentGeminiInteractionsAppGroupIdResult> => {
    return fetchWithRetry({ maxAttempts: 3, retryDelay: 1000, expBackoff: true })(
      `/ai_agent/gemini_interactions/${appGroupId}`,
      "POST",
      {
        model,
        input,
        mode,
        previous_interaction_id: previousInteractionId,
        request_id: requestId,
        user_message_id: userMessageId,
        session_id: sessionId,
        frontend_tools: frontendTools,
        locale,
        browser_locale: browserLocale,
        transport,
        prompt_source: promptSource,
        mock_response_length: mockResponseLength,
        dust_session_id: dustSessionId,
        attached_files: serializeAttachedFiles(attachedFiles),
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
